// extracted by mini-css-extract-plugin
module.exports = {"top_bar":"MyProposalTopBarView_top_bar__340sN","proposal_button":"MyProposalTopBarView_proposal_button__3qbeg","active":"MyProposalTopBarView_active__3KQSR"};